var _g;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgSupremacyLogo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 163.076 19.072"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 54056"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 34108",
    d: "M.387 18.572h12.52l2.582-2.582V9.872L12.907 7.29h-7.1l-.645-.645v-.981l.645-.645H15.1l.387-.387V.889L15.1.501H2.582L0 3.083v6.118l2.582 2.582h7.1l.645.645v.981l-.645.645H.387L0 14.441v3.743z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 34107",
    d: "M33.689.501h-4.388l-.387.387v12.52l-.645.645H22.33l-.645-.645V.888l-.387-.387h-4.389l-.387.387v15.1l2.582 2.582h12.391l2.582-2.582V.888z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 34106",
    d: "M35.109 18.185l.387.387h4.389l.387-.387v-3.584h9.81l2.582-2.582V3.087L50.082.501H35.496l-.387.387zm5.163-8.106v-5.06h6.583l.645.645v3.769l-.645.645z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 34100",
    d: "M54.084 18.572h4.389l.387-.387v-3.554h6.583l.645.645v2.909l.387.387h4.389l.387-.387v-3.012l-1.947-2.672v-.155l1.947-2.565V3.086L68.67.501H54.084l-.387.387v17.3zm4.776-8.459V5.019h6.583l.645.645v3.8l-.645.645z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 34101",
    d: "M72.671 18.572h14.713l.387-.387v-3.744l-.387-.387h-9.937v-2.22h7.822l.387-.387V7.701l-.387-.387h-7.822v-2.3h9.937l.387-.387V.884l-.387-.383H72.671l-.387.387v17.3z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 34145",
    d: "M104.426 18.571l-.387-.389V8.863l-4.658 5.924h-.709l-4.7-5.924v9.319l-.389.389h-4.387l-.389-.389V.882l.389-.387h4.336l.439.284L98.7 7.222h.658l4.707-6.444.439-.284h4.311l.387.387v17.3l-.387.389z",
    stroke: "rgba(0,0,0,0)"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 34103",
    d: "M110.619 18.572h4.389l.387-.387v-3.594h7.228v3.593l.387.387h4.389l.387-.387v-15.1L125.205.501h-12.391l-2.582 2.582v15.1zm4.776-8.5v-4.41l.645-.645h5.938l.645.645v4.41z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 34104",
    d: "M143.793.501h-12.391l-2.582 2.582v12.908l2.582 2.582h12.391l2.582-2.582v-3.795l-.387-.387h-4.389l-.387.387v1.213l-.645.645h-5.939l-.645-.645V5.664l.645-.645h5.938l.645.645v1.213l.387.387h4.389l.387-.387V3.082z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 34144",
    d: "M148.034 18.533l-.627-.629v-2.55l4.209-5.388v-.9l-4.209-5.387V1.144l.645-.645h3.424l3.416 4.373h.7l3.416-4.373h3.414l.654.654v2.526l-11.6 14.851z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Subtraction 189",
    d: "M162.447 18.554h-4.435l5.065-6.482v5.852l-.63.629z"
  }))));
}

export default SvgSupremacyLogo;